module.exports = __webpack_public_path__ + "static/img/strategy-big-right.79855052.png";